import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { ContactInfoPayload, formatContactInfoData } from './formatData';

const useContactInfoQuery = (contactId?: string) => {
  const { data, isLoading, isSuccess, refetch, isRefetching } = useQuery(
    [API_URL.CONTACTS_BY_CONTACT_ID(contactId || '')],
    () => api.get<ContactInfoPayload>(API_URL.CONTACTS_BY_CONTACT_ID(contactId || '')),
    {
      enabled: !!contactId,
    }
  );

  const formattedData = useMemo(() => formatContactInfoData(data?.data), [data]);

  return {
    formattedData,
    isLoading,
    isSuccess,
    refetch,
    isRefetching,
  };
};

export default useContactInfoQuery;
